// THE BOOT PROCEDURAL TEXTURES' PAINTERS (R8c5): the 2D canvas calls of
// structs2.js detailTexture (the lit / grate batches' detail grain) and
// roads3d.js boreTexture (the bore lining), moved here VERBATIM — the same
// calls, the same hash `rnd` (never Math.random), the same order: the same
// pixels. They run in the client worker pool on an OffscreenCanvas
// (pool-veg.js tex.paint); the main thread only puts the bytes into a canvas
// and uploads it (roads3d.js poolTexture). Pure + DOM-free (the worker
// bundle): a painter gets a 2D context, never makes a canvas.
//
//   TEX_PAINT[kind] = {S, paint(g, S, args)}
//     detail  S 256  args {mean}: DRAW.detail_mean.v (structplan.js) — a
//             neutral speckle of mean `mean` (sRGB 0..1)
//     bore    S 256  args {}: dark damp rock / shotcrete with faint ring-joint
//             banding (DRAW.bore_tex_mean was measured on these calls)

// the deterministic hash (roads3d.js / structs2.js's own, the same function)
export const rnd = (i) => {
  let h = (i * 374761393) ^ 0x5bf03635;
  h = (h ^ (h >> 13)) * 1274126177;
  return (((h ^ (h >> 16)) >>> 0) % 1000) / 1000;
};

// the lit batch's detail grain: a neutral speckle (mean args.mean)
export function paintDetail(g, S, args) {
  const base = Math.round(args.mean * 255);
  g.fillStyle = `rgb(${base},${base},${base})`; g.fillRect(0, 0, S, S);
  for (let i = 0; i < S * S / 2; i++) {
    const v = base + (rnd(i) - 0.5) * 34;
    g.fillStyle = `rgb(${v | 0},${v | 0},${(v * 0.985) | 0})`;
    g.fillRect((rnd(i + 7919) * S) | 0, (rnd(i + 104729) * S) | 0, 2, 2);
  }
}

// bore lining: dark, damp rock/shotcrete with faint ring-joint banding
export function paintBore(g, S) {
  g.fillStyle = '#1b1a1c'; g.fillRect(0, 0, S, S);
  for (let i = 0; i < S * S / 2; i++) {
    const v = 30 + (rnd(i) - 0.5) * 30;
    g.fillStyle = `rgb(${v | 0},${(v * 0.97) | 0},${(v * 1.02) | 0})`;
    g.fillRect((rnd(i + 7919) * S) | 0, (rnd(i + 104729) * S) | 0, 2, 2);
  }
  g.fillStyle = 'rgba(8,8,10,0.55)';           // shutter-joint rings
  for (let y = 0; y < S; y += 64) g.fillRect(0, y, S, 3);
  g.fillStyle = 'rgba(70,68,64,0.18)';         // damp streaks
  for (let i = 0; i < 60; i++) {
    g.fillRect((rnd(i + 31) * S) | 0, 0, 1 + ((i % 3) | 0), S);
  }
}

export const TEX_PAINT = {
  detail: { S: 256, paint: paintDetail },
  bore: { S: 256, paint: paintBore },
};
